import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../services/auth/auth.service';
import { CurrentUserContextService } from '../../services/current-user-context/current-user-context.service';
import { OrganizationGroupService } from '../../services/organization-group/organization-group.service';
import { PendingReviewsService } from '../../services/pending-reviews/pending-reviews.service';
import { UserRole, UserRoleService } from '../../services/user-role/user-role.service';
import { GetMeResponse, UsersService } from '../../services/users/users.service';

@Component({
  selector: 'app-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent implements OnInit, OnDestroy {
  @Output() openFirmPicker = new EventEmitter<void>();

  readonly app_title = environment.app_title || 'Saffron';
  readonly UserRole = UserRole;
  readonly activeOrg$ = this.organizationGroupService.activeOrg$;
  readonly activeGroup$ = this.organizationGroupService.activeGroup$;
  readonly displayOrganization$ = this.userContext.displayOrganization$;

  isAuthenticated = false;
  current_user: GetMeResponse | null = null;
  pending_review_count = 0;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    private usersService: UsersService,
    public userRoleService: UserRoleService,
    private pendingReviewsService: PendingReviewsService,
    private organizationGroupService: OrganizationGroupService,
    private userContext: CurrentUserContextService,
    private cdr: ChangeDetectorRef,
  ) {}

  get userInitial(): string {
    return this.current_user?.USER?.FIRST_NAME?.charAt(0)?.toUpperCase() ?? '';
  }

  ngOnInit(): void {
    this.authService.authStatus$.pipe(takeUntil(this.destroy$)).subscribe((isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
      if (isAuthenticated) {
        this.fetchCurrentUser();
      } else {
        this.current_user = null;
      }
      this.cdr.detectChanges();
    });

    this.pendingReviewsService.pending_review_count$
      .pipe(takeUntil(this.destroy$))
      .subscribe((count) => {
        this.pending_review_count = count;
        this.cdr.detectChanges();
      });

    if (this.authService.isAuthenticated()) {
      this.fetchCurrentUser();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onFirmPickerClick(): void {
    this.openFirmPicker.emit();
  }

  logout(): void {
    void this.authService.logout();
  }

  private fetchCurrentUser(): void {
    void this.usersService
      .getCurrentUser()
      .then((user) => {
        this.current_user = user;
        this.cdr.detectChanges();
      })
      .catch((error: unknown) => {
        console.error('SideNavComponent: failed to fetch current user', error);
      });
  }
}
